import axios from 'axios'

import { REVIEWS as ENDPOINT } from '../common/endpoints'

async function updateList (
	{ id, code, revlang },
	callback
) {

	if (!window.motostorm) {
		console.warn('missing global namespace variables')
	}

	try {
		
		const { lang } = window.motostorm		
		const res = await axios.get(ENDPOINT, {
			params: {
				prodid: id,
				pagelang: lang,
				codice: code,
				revlang: revlang
			},
		})

		if (typeof callback === 'function') {
			callback(res)
		}
	} catch (error) {
		console.warn(error)
	}

	if (typeof callback === 'function') {
		callback(null)
	}

	return false
}

const productCode = window.motostorm.product.productCode
const productId = window.motostorm.product.productId
const reviewsListWrapper = document.getElementById('product-reviews-list')
const languageFlags = document.querySelectorAll('.j-product-reviews__language-button')

if (languageFlags) {
	languageFlags.forEach(item => {
		if(!item.disabled){
			item.addEventListener('click', function() {
				updateList({
					id: productId,
					code: productCode,
					revlang: item.value
				}, (res) => {
					if (res) {
						reviewsListWrapper.innerHTML = res.data
					}
				})
			})
		}
	})
}
